import { Modal, Container } from "react-bootstrap";
import React from "react";
import { Row,Col,Button } from "antd";

function ResetModal(props) {
  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size={props.size} centered>
        <Modal.Body>
          <label
            style={{
              fontSize: "30px",
              fontFamily: "Made-Tommy-Soft-Medium",
              color: "#545454",
            }}
          >
            {" "}
            RESET {props.title}{" "}
          </label>
          <div className="col-sm-12">
            <hr />
            <Container fluid className="modal-cont justify-content-center">
              {props.children}
            </Container>

            {/* <div className="col-sm-12 mt-3 d-flex justify-content-end">
              <button className="button-secondary me-3" onClick={props.onHide}>
                Cancel
              </button>
              <button className="button-primary" onClick={props.onSave}>
                Reset
              </button>
            </div> */}
            <Row className="mt-4 d-flex justify-content-end">
              <Col xs={12}>
              <Row className=" w-100">
                <Col xs={12}>
                  <Button
                    className="button-secondary me-3 w-100"
                    onClick={props.onHide}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col xs={12}>
                    <Button
                      type="primary"
                      className="button-primary w-100"
                      onClick={props.onSave}
                    >
                      Reset
                    </Button>
                </Col>
              </Row>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

ResetModal.defaultProps = {
  title: "",
  // type:"",
  size: "xl",
  show: () => {},
  onHide: () => {},
  onSave: () => {},
};

export default ResetModal;
